import { SidePanel } from "@wix/design-system";
import classNames from "classnames";
import React from "react";
import classes from "./panel-header-scss.js";
const PanelHeader = ({ title, subtitle, className }) => {
  return /* @__PURE__ */ React.createElement("div", { "data-drag-handler": "true" }, /* @__PURE__ */ React.createElement(
    SidePanel.Header,
    {
      showDivider: true,
      className: classNames(classes.header, className),
      title,
      subtitle
    }
  ));
};
export {
  PanelHeader
};
//# sourceMappingURL=panel-header.js.map
